import axios from 'axios';

// Get help inquiry -  ヘルプ問い合わせ取得
export const getHelpInquiries = async () => {
  const result = await axios.get(`${process.env.VUE_APP_FAQ_URL}/faq.json`);
  return result.data;
};
